import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import ReactEcharts from 'echarts-for-react';
import {
  getIsLoggedIn,
  getIsStarted,
  getLatestRefreshSeconds,
  getHistoryRefreshSeconds,
  getEmail,
  getTicker,
} from '../../reducers/params';
import {
  setIsStarted
} from '../../actions/params';
import {
  loadLatestData,
  loadHistoryData,
} from '../../actions/data';
import {
  getLatestData,
  getHistoryData,
} from '../../reducers/data';
import { AnimateOnChange } from 'react-animation'
import ReactTooltip from 'react-tooltip';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle, faPlayCircle } from '@fortawesome/free-solid-svg-icons';
import './App.css';

library.add(faInfoCircle, faPlayCircle);

class App extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      showPrivate: false,
    };
    this.props.loadLatestData();
  }

  timerLatest() {
    this.props.loadLatestData();
  }

  timerHistory() {
    this.props.loadHistoryData();
  }

  componentDidMount() {
    const {
      isStarted,
      latestRefreshSeconds,
      historyRefreshSeconds,
      clientEmail,
      isLoggedIn,
    } = this.props;

    if (isStarted) {
      this.props.loadLatestData(clientEmail);
      this.props.loadHistoryData();
      this.intervalIdLatest = setInterval(this.timerLatest.bind(this), latestRefreshSeconds * 1000);
      this.intervalIdHistory = setInterval(this.timerHistory.bind(this), historyRefreshSeconds * 1000);
    } else if (isLoggedIn) {
      this.props.loadLatestData();
    }

    if (window.location.hash) {
      const hash = window.location.hash.substring(1);
      if (hash === 'enav') {
        let nav = document.getElementById('enav');
        if (nav) {
          nav.scrollIntoView({ top: 646, behavior: 'smooth' });
        }
      }
    }
  }

  componentDidUpdate() {
    const {
      latestData,
    } = this.props;
    // send event for sitecore template nav to display or not
    const showApp = latestData.lastUpdated && this.isToday(new Date(latestData.lastUpdated)) ? true : false;
    if (showApp) {
      console.log('eNav.loaded')
      window.dispatchEvent(new Event('eNav.loaded'));
    } else {
      console.log('eNav.canceled')
      window.dispatchEvent(new Event('eNav.canceled'));
    }
  }

  startFeed() {
    const {
      isLoggedIn,
      latestRefreshSeconds,
      historyRefreshSeconds,
      clientEmail,
    } = this.props;

    if (isLoggedIn) {
      this.props.setIsStarted(true);
      this.props.loadLatestData(clientEmail);
      this.props.loadHistoryData();
      this.intervalIdLatest = setInterval(this.timerLatest.bind(this), latestRefreshSeconds * 1000);
      this.intervalIdHistory = setInterval(this.timerHistory.bind(this), historyRefreshSeconds * 1000);
    }
  }

  componentWillUnmount() {
    clearInterval(this.intervalIdLatest);
    clearInterval(this.intervalIdHistory);
  }

  mouseOn() {
    const {
      isLoggedIn,
    } = this.props;

    if (!isLoggedIn) {
      this.setState({
        showPrivate: true,
      });
    }
  }

  mouseOff() {
    this.setState({
      showPrivate: false,
    });
  }

  isToday(someDate) {
    const today = new Date()
    return someDate.getDate() === today.getDate() &&
      someDate.getMonth() === today.getMonth() &&
      someDate.getFullYear() === today.getFullYear()
  }

  render() {
    const {
      showPrivate,
    } = this.state;

    const {
      isLoggedIn,
      isStarted,
      latestData,
      historyData,
      ticker,
    } = this.props;

    const showApp = latestData.lastUpdated && this.isToday(new Date(latestData.lastUpdated)) ? true : false;
    const lastUpdatedAsk = latestData.enavAskPriceTime ? `${new Date(latestData.enavAskPriceTime).toLocaleDateString()} ${new Date(latestData.enavAskPriceTime).toLocaleTimeString()}` : '-----';
    const lastUpdatedBid = latestData.enavBidPriceTime ? `${new Date(latestData.enavBidPriceTime).toLocaleDateString()} ${new Date(latestData.enavBidPriceTime).toLocaleTimeString()}` : '-----';
    const enavBidPrice = latestData.enavBidPrice ? `$${latestData.enavBidPrice}` : '-----';
    const enavAskPrice = latestData.enavAskPrice ? `$${latestData.enavAskPrice}` : '-----';

    if (showApp && isLoggedIn) {
      return (
        <div className="enav-app">
          <div className='row'>
            <div className='col-md-6'>
              <div className='title'>
                Real-Time eNAV
                <FontAwesomeIcon style={{ verticalAlign: 'super', fontSize: '14px', color: '#5b6770', marginLeft: '2px', cursor: 'pointer' }} data-tip data-for={'enavInfo'} icon="info-circle" size="xs" />
                <ReactTooltip arrowColor="transparent" id={'enavInfo'} type='light' className="enavtip" effect="float">
                  <strong>What is eNAV</strong><br />
                  eNAV is a proprietary product from Virtu, one of the largest ETF market makers, that estimates the value of an ETF basket. It shows where it thinks the value of the bid and ask of the underlying constituents are. This is most useful for asset classes that have stale pricing due to either time zone differences or lack of centralized trading, such as international equities and fixed income.
                  <br /><br />
                  <strong>How do I use eNAV</strong><br />
                  eNAV is a great tool for getting a sense of where the bid/ask of the ETF should be. It is important to note, though, that eNAV does not include transaction costs, so the market pricing of the ETF could be wider than eNAV. eNAV can help you decide what limit price to use. When in doubt, email us at uscapmkts@wisdomtree.com for guidance.
                </ReactTooltip>
              </div>
              <table className='table'>
                <thead>
                  <tr>
                    <td>&nbsp;</td>
                    <td>Last Updated</td>
                    <td style={{ textAlign: 'center' }}>Price</td>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{ticker} eNAV Bid</td>
                    {!isLoggedIn &&
                      <td colSpan='2' style={{ textAlign: 'center', fontStyle: 'italic' }}>Start real-time eNAV to view</td>
                    }
                    {isLoggedIn &&
                      <React.Fragment>
                        <td>{lastUpdatedBid}</td>
                        <td style={{ textAlign: 'center', fontSize: '14px' }}>
                          <AnimateOnChange
                            animationIn="bounceIn"
                            animationOut="bounceOut"
                            durationOut={500}
                          >
                            {enavBidPrice}
                          </AnimateOnChange>
                        </td>
                      </React.Fragment>
                    }
                  </tr>
                  <tr>
                    <td>{ticker} eNAV Ask</td>
                    {!isLoggedIn &&
                      <td colSpan='2' style={{ textAlign: 'center', fontStyle: 'italic' }}>Start real-time eNAV to view</td>
                    }
                    {isLoggedIn &&
                      <React.Fragment>
                        <td>{lastUpdatedAsk}</td>
                        <td style={{ textAlign: 'center', fontSize: '14px' }}>
                          <AnimateOnChange
                            animationIn="bounceIn"
                            animationOut="bounceOut"
                            durationOut={500}
                          >
                            {enavAskPrice}
                          </AnimateOnChange>
                        </td>
                      </React.Fragment>
                    }
                  </tr>
                </tbody>
              </table>
            </div>
            <div className='col-md-6'>
              <div className='title'>Today's eNAV History</div>
              {isStarted &&
                <ReactEcharts
                  option={this.getChart(historyData, ticker)}
                  theme='default'
                  style={{ height: 200 }}
                />
              }
              {!isStarted && !showPrivate &&
                <div className='start-box' onMouseEnter={() => this.mouseOn()} onClick={() => this.startFeed()}>
                  Start real-time eNAV<br />and view today's history<br />
                  <FontAwesomeIcon style={{ color: '#FFFFFF', marginTop: '20px' }} icon="play-circle" size="2x" />
                </div>
              }
              {!isStarted && showPrivate && !isLoggedIn &&
                <div className='start-box-login' onMouseLeave={() => this.mouseOff()}>
                  Start real-time eNAV<br />and view today's history<br />
                  <a href={`/sign-in?redirect=${window.location.href}?enav=true`}>Sign In</a>
                  <a href={`/registration/my-profile?redirect=${window.location.href}?enav=true`}>Register</a>
                  <div style={{ marginTop: '8px', marginBottom: '16px', fontSize: '14px' }}>for Financial Professionals only</div>
                </div>
              }
            </div>
          </div>
          {isStarted &&
            <div className='row' style={{ marginTop: '10px', fontStyle: 'italic' }}>
              <div className='col-md-6'>
                refreshes every 5 seconds
              </div>
              <div className='col-md-6'>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;refreshes every 5 minutes
              </div>
            </div>
          }
          <div className='row disclosures'>
            <div className='col-md-12'>
              {isLoggedIn &&
                <React.Fragment>
                  <a href="https://www.wisdomtree.com/-/media/us-media-files/documents/secure-resource-library/wisdomtree-etf-education-about-enav" target="_new" style={{ fontSize: '14px' }}>View eNAV FAQ</a><br /><br />
                </React.Fragment>
              }
              The eNAVs listed on this website are calculated by Virtu ITG Solutions Network LLC (“Virtu”). The eNAV is determined, and underlying components are fair valued, according to Virtu’s established methodology (the “eNAV methodology”). The eNAV is continuously updated and disseminated during U.S. market trading hours. The eNAV is indicative and is for informational and reference purposes only. The eNAV methodology may differ from the Fund’s NAV. While the eNAV does include a fair valuation aspect, the eNAV may be based on stale information. WisdomTree is not responsible or liable for, and does not have any role in, the calculation or application of the eNAV methodology. The eNAV is not intended as investment advice or solicitation and does not guarantee the value of any Funds or its worth. You are advised to seek independent advice and/or consult relevant laws, regulations and rules prior to investing and/or trading. The Funds are not sponsored, endorsed, sold or marketed by Virtu.
            </div>
          </div>
        </div>
      );
    } else {
      return null;
    }
  }

  getChart(data, ticker) {

    // filter for only todays times and unique
    const uniqueCheck = {};
    data = data.filter((tick) => {
      const tickTime = new Date(tick.lastUpdated);
      const currTime = new Date();
      if (tickTime.getDay() === currTime.getDay()) {
        if (uniqueCheck[tick.lastUpdated]) {
          return false;
        }
        uniqueCheck[tick.lastUpdated] = true;
        return true;
      } else {
        return false;
      }
    });

    const chartColors = ['#3a6cc9', '#00A9E4'];
    const legendData = [`${ticker} eNAV Bid`, `${ticker} eNAV Ask`];

    const xaxisData = data.map((tick) => {
      return (new Date(tick.lastUpdated).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }));
    });

    const bidData = data.map((tick) => {
      return (tick.enavBidPrice);
    });

    const askData = data.map((tick) => {
      return (tick.enavAskPrice);
    });

    const minVal = Math.min.apply(Math, bidData.concat(askData));
    const maxVal = Math.max.apply(Math, bidData.concat(askData));

    const seriesData = [];
    seriesData.push({ name: `${ticker} eNAV Bid`, barGap: 0, type: 'line', data: bidData });
    seriesData.push({ name: `${ticker} eNAV Ask`, barGap: 0, type: 'line', data: askData });

    return {
      legend: {
        itemGap: 20,
        textStyle: {
          // fontWeight: 'bold',
          fontSize: '14',
        },
        data: legendData,
      },
      grid: {
        top: '20%',
        left: '3%',
        right: '5%',
        bottom: '0%',
        containLabel: true,
      },
      tooltip: {
        trigger: 'axis',
        formatter: function (params) {
          let res = `<strong>${params[0].name}</strong>`;
          for (let i = 0, l = params.length; i < l; i++) {
            res += `<br/>${params[i].seriesName} : $${Number(params[i].value).toFixed(3)}`;
          }
          return res;
        },
        backgroundColor: '#FFF',
        borderWidth: 1,
        borderColor: '#05A9B1',
        borderRadius: 0,
        textStyle: {
          color: '#5B6770',
          align: 'left',
        },
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        data: xaxisData,
        axisLabel: {
          fontSize: 12,
          color: '#8C959B',
          rotate: 0,
          // align: 'right',
        },
        axisLine: {
          lineStyle: {
            color: '#8C959B',
          }
        },
        axisTick: {
          show: false
        },
        splitLine: {
          show: false
        },
      },
      yAxis: {
        min: minVal,
        max: maxVal,
        type: 'value',
        axisLabel: {
          fontSize: 12,
          color: '#8C959B',
          formatter: function (val) {
            return `$${Number(val).toFixed(2)}`;
          }
        },
        axisTick: {
          show: false
        },
        axisLine: {
          lineStyle: {
            color: '#8C959B',
          }
        },
        splitNumber: 5,
        splitLine: {
          show: false
        },
      },
      series: seriesData,
      color: chartColors,
    };
  }

}

function mapStateToProps(state) {
  return {
    ticker: getTicker(state),
    isLoggedIn: getIsLoggedIn(state),
    isStarted: getIsStarted(state),
    latestRefreshSeconds: getLatestRefreshSeconds(state),
    historyRefreshSeconds: getHistoryRefreshSeconds(state),
    latestData: getLatestData(state),
    historyData: getHistoryData(state),
    clientEmail: getEmail(state),
  };
}

export default connect(
  mapStateToProps,
  {
    setIsStarted,
    loadLatestData,
    loadHistoryData,
  },
)(App);







// WEBPACK FOOTER //
// ./src/components/App/App.js